// eslint-disable-next-line import/order
import './polyfills';

import { createRoot } from 'react-dom/client';

import { RootConfig } from '../types/config.types';

import { App } from './App';
import { ReactConfigLoader } from './libs';

import './assets/styles/styles.scss';

// eslint-disable-next-line unicorn/prefer-top-level-await
ReactConfigLoader.init().then((config: RootConfig) => {
  const container = document.querySelector('#root');
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  const root = createRoot(container!);
  root.render(<App config={config} />);
});
